import { cn } from "@/lib/utils";
import type React from "react";

export const SimpleSectionTitle = ({
  title,
  subtitle,
  className,
  noH2,
  dark,
}: {
  title: React.ReactNode;
  subtitle: React.ReactNode;
  className?: string;
  noH2?: boolean;
  dark?: boolean;
}) => (
  <div
    className={cn(
      "text-center grid justify-center gap-1 md:gap-2 px-2.5",
      className,
    )}
  >
    <div className="text-5xl leading-snug font-medium tracking-tighter sm:text-6xl sm:leading-tight">
      {noH2 ? <p>{title}</p> : <h2>{title}</h2>}
    </div>
    <p
      className={cn(
        "mx-auto font-light max-w-[700px] text-lg tracking-[0.01em]",
        dark && "text-neutral-400",
        !dark && "text-neutral-500",
      )}
    >
      {subtitle}
    </p>
  </div>
);
